module.exports = __webpack_public_path__ + "lp/img/check_circle.9b286c5a.svg";